import { useQuery } from '@tanstack/react-query'
import { useBillingAndUsageAccess } from './useBillingAndUsageAccess'
import { useActiveEnvironment } from '../../../hooks/useEnvironments'
import { AppHTTPService } from '../../../api/http-service'

export const usePaymentAccess = () => {
  const { environment: activeEnvironment } = useActiveEnvironment()

  const { data: limitsData, isLoading: limitsLoading } = useQuery({
    queryKey: ['getLimits'],
    queryFn: () => AppHTTPService.axios.get(`/v1/billing/limits`),
  })
  const { data: planData, isLoading: planLoading } = useQuery({
    queryKey: ['getPlan'],
    queryFn: () => AppHTTPService.axios.get(`/v1/billing/plan`),
  })

  const { fileUploadLocked, sheetIsLocked, filesUsage, pdvUsage, freeFileLimit, freePdvLimit, usageBannerProps } =
    useBillingAndUsageAccess({
      limitsData,
      planData: planData?.data,
      environment: activeEnvironment,
      isGuest: false,
    })

  return {
    loading: limitsLoading || planLoading,
    fileUploadLocked,
    sheetIsLocked,
    filesUsage,
    pdvUsage,
    freeFileLimit,
    freePdvLimit,
    usageBannerProps,
  }
}
